import React, {useEffect, useState} from 'react';
import {Button, Flexbox, Label} from "../index";
import {checkIsNumber, getJsonValue, getDefStr, isBoolTrue, parseInteger} from "../utils/ReactUtils";
import {RippleVarVariant} from "../config/FusionConfig";
//https://dribbble.com/shots/23066481-Date-and-Time-Picker-Theming
//https://dribbble.com/shots/23339215-Date-Time-Picker-Daily-UI
const DurationPicker = React.memo(({
                                       wrapperClassName = '',
                                       buttonClassName = '',
                                       textWrapperClassName = '',
                                       inputClassName = '',
                                       labelClassName = '',

                                       wrapperStyle = {},
                                       textWrapperStyle = {},
                                       inputStyle = {},
                                       buttonStyle = {},
                                       buttonHoverStyle = {},
                                       labelStyle = {},

                                       defHour = 1,
                                       defMinute = 0,
                                       defSecond = 0,
                                       showHours = true,
                                       showMinutes = true,
                                       showSeconds = true,

                                       inputId,
                                       onChange,
                                       onHourChange,
                                       onMinuteChange,
                                       onSecondChange,

                                       hourMin = 0,
                                       hourMax = 12,
                                       minuteMin = 0,
                                       minuteMax = 60,
                                       secondMin = 0,
                                       secondMax = 60,

                                       buttonProps = {}, inputProps = {},
                                   }) => {
    const TAG = 'DurationPicker';

    const [hourValue, setHourValue] = useState(getDefStr(defHour, hourMin));
    const [minuteValue, setMinuteValue] = useState(getDefStr(defMinute, minuteMin));
    const [secondValue, setSecondValue] = useState(getDefStr(defSecond, secondMin));
    const [isInputKeyDown, setInputIsKeyDown] = useState(false);

    useEffect(() => {
        // if (onChange) onChange(hourValue, minuteValue, secondValue);
        if (onChange) onChange(
            parseInteger(hourValue) < 10 ? `0${hourValue}` : hourValue,
            parseInteger(minuteValue) < 10 ? `0${minuteValue}` : minuteValue,
            parseInteger(secondValue) < 10 ? `0${secondValue}` : secondValue,
        );
    }, [hourValue, minuteValue, secondValue]);
    // useEffect(() => {
    //     if (!checkNullStr(hourValue)) setHourValue(getDefStr(defHour, hourMin));
    // }, [defHour]);
    // useEffect(() => {
    //     if (!checkNullStr(minuteValue)) setMinuteValue(getDefStr(defMinute, minuteMin));
    // }, [defMinute]);
    // useEffect(() => {
    //     if (!checkNullStr(secondValue)) setSecondValue(getDefStr(defSecond, secondMin));
    // }, [defSecond]);


    return (<Flexbox className={`m-0 p-0 ${wrapperClassName}`} style={wrapperStyle}
                     wrap={'nowrap'} direction={'row'}
                     justifyAt={'start'} alignAt={'center'}>
        {/*hour*/}
        {isBoolTrue(showHours) && createSingleBox({
            label: 'hour', onValueChange: onHourChange, min: hourMin, max: hourMax, stateValue: hourValue, setState: setHourValue,
        })}

        {/*minute*/}
        {isBoolTrue(showMinutes) && createSingleBox({
            label: 'minute', onValueChange: onMinuteChange, min: minuteMin, max: minuteMax, stateValue: minuteValue, setState: setMinuteValue,
        })}

        {/*second*/}
        {isBoolTrue(showSeconds) && createSingleBox({
            label: 'second', onValueChange: onSecondChange, min: secondMin, max: secondMax, stateValue: secondValue, setState: setSecondValue,
        })}
    </Flexbox>);

    function createSingleBox({
                                 label, stateValue, setState, onValueChange, min, max,
                             }) {
        return <div className={`p-0 pe-3 d-flex fd-column jc-center al-center`}>
            {createAngleButton(false, stateValue, setState, min, max, onValueChange)}
            {createValueLabel(label, stateValue, setState, min, max, onValueChange)}
            {createAngleButton(true, stateValue, setState, min, max, onValueChange)}
        </div>
    }

    function createAngleButton(isUp, stateValue, setState, min, max, onValueChange) {
        return <Button
            className={`m-0 p-2 rounded-2 ${buttonClassName}`}
            outlined={false}
            variant={''}
            color={''}
            style={{
                border: '1px solid lightgray', ...buttonStyle
            }}
            hoverStyle={{
                color: 'white', backgroundColor: 'var(--primary)', ...buttonHoverStyle,
            }}
            width={'30px'}
            height={'30px'}
            enableFocusStyling={false}
            rippleColor={getJsonValue(buttonProps, 'rippleColor', RippleVarVariant.light)}
            iconClass={isBoolTrue(isUp) ? 'fa fa-angle-down' : 'fa fa-angle-up'}
            onClick={() => {
                // const value = isBoolTrue(isUp) ? (stateValue == min ? max : stateValue - 1) : (stateValue == max ? min : stateValue + 1);
                const value = isBoolTrue(isUp) ? (stateValue == min ? max : (stateValue - 1 < min ? min : stateValue - 1)) : (stateValue == max ? min : stateValue + 1);
                setState(value)
                if (onValueChange) onValueChange(parseInteger(value) < 10 ? `0${value}` : value);
                // if (onValueChange) onValueChange(value);
            }}
            {...buttonProps}
        />
    }

    function createValueLabel(label, stateValue, setState, min, max, onValueChange) {
        return <div className={`m-0 p-0 pb-2 pt-1 mb-1x d-flex fd-column jc-center al-center ${textWrapperClassName}`}
                    style={textWrapperStyle}>
            {/*<Label className={'fw-semi-bold fs-normal p-0 m-0'}>{stateValue}</Label>*/}
            <input
                className={`fw-semi-bold fs-normal text-center-force text-nowrap p-0 px-2 py-1x my-1 m-0 text-start rounded-2 border-0-5 border-success-hover border-primary-focus transition-sm outline-none-all ${inputClassName}`}
                id={inputId}
                style={{
                    width: '36px', maxWidth: '36px', minWidth: '36px', height: '28px', borderColor: 'transparent', ...inputStyle
                }}
                // value={stateValue}
                // value={parseInteger(stateValue) == 0 ? '00' : (parseInteger(stateValue) == 1 ? '01' : stateValue)}
                value={parseInteger(stateValue) < 10 ? `0${stateValue}` : stateValue}
                min={min}
                max={max}
                // type={'number'}
                onChange={(e) => {
                    const value = parseInteger(e.target.value);
                    // printLog(TAG, 'createValueLabel.input.onChange.value:', value);
                    if (value <= max && value >= min && checkIsNumber(value)) {
                        setState(value)
                        if (onValueChange) onValueChange(value);
                    }
                }}
                // onKeyDown={(e) => {
                //     setInputIsKeyDown(true);
                //     let value = stateValue;
                //     if (e.key === 'ArrowDown') {
                //         value = stateValue == min ? max : (stateValue - 1 < min ? min : stateValue + 2);
                //     } else if (e.key === 'ArrowUp') {
                //         // value = stateValue == max ? min : stateValue - 2;
                //         value = stateValue == max ? min : (stateValue - 2 < min ? min : stateValue - 2);
                //     }
                //     handleValueInputChange(e, value, setState, min, max, onValxueChange)
                // }}
                onKeyUp={(e) => {
                    // if (!isInputKeyDown) {
                    handleValueInputChange(e, stateValue, setState, min, max, onValueChange);
                    // }
                    // setInputIsKeyDown(false);
                }}
            />
            <Label className={`fs-sm-md xfw-semi-bold p-0 m-0 mt-n1 ${labelClassName}`}
                   style={labelStyle}>
                {parseInteger(stateValue) > 1 ? `${label}s` : label}
                {parseInteger(stateValue) <= 1 && <span className={''}> </span>}
            </Label>
        </div>
    }

    function handleValueInputChange(event, stateValue, setState, min, max, onValueChange) {
        try {
            if (event.key === 'ArrowUp') {
                const value = stateValue == max ? min : stateValue + 1;
                setState(value)
                if (onValueChange) onValueChange(value);
            } else if (event.key === 'ArrowDown') {
                const value = stateValue == min ? max : stateValue - 1;
                setState(value)
                if (onValueChange) onValueChange(value);
            }
        } catch (error) {
            // printError(TAG,error);
        }
    }
});

export default DurationPicker;
